<template>
  <div :style="divStyle">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Tabs>
      <TabPane label="列表结构" name="list" icon="ios-list">
        <Row style="padding-bottom: 10px;">
          <Col span="4" style="padding-right: 10px;">
            <Button type="primary" long @click="onClickSearch">检索</Button>
          </Col>
        </Row>
        <Table
          ref="selectionTable"
          :max-height="height"
          :data="showData"
          :columns="showColumns"
          stripe
          border
        ></Table>
        <Page
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          style="text-align:right"
        ></Page>
      </TabPane>
      <TabPane label="树形结构" name="tree" icon="ios-git-merge">
        <Tree :data="data5" :render="renderContent"></Tree>
      </TabPane>
    </Tabs>

    <!-- 模态框 -->
    <Modal title="Title" v-model="isModalShow" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>{{modalTitle}}</span>
      </p>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <span>父级机构名称</span>
          <Input readonly v-model="parentNodeName" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>父级机构编号</span>
          <Input readonly v-model="parentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前机构名称</span>
          <Input
            v-model="currentNodeName"
            placeholder="请输入当前机构名称"
            style="margin-left:10px; width: 150px"
          />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前机构编号</span>
          <Input readonly v-model="currentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前机构描述</span>
          <Input v-model="currentNodeRemark" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前机构类型</span>
          <Select
            v-model="currentNodeType"
            style="margin-left:10px; width:150px"
            placeholder="请选机构类型"
          >
            <Option v-for="(value, key) in addressTypeEnum" :value="value" :key="key">{{value}}</Option>
          </Select>
        </div>
      </div>
      <div slot="footer">
        <Button
          :loading="isLoading"
          icon="md-search"
          type="info"
          size="large"
          long
          @click="modalButtonClick"
        >{{modalButtonName}}</Button>
      </div>
    </Modal>
    <!-- 模态框 -->
    <Modal v-model="isShowModalSearch" :mask-closable="false" width="380">
      <p slot="header" style="color:#2d8cf0;text-align:center">
        <Icon type="md-create" />
        <span>按照输入的字段检索管辖机构</span>
      </p>
      <Form ref="searchParam" :label-width="100" :model="searchParam">
        <FormItem prop="governingBodyName" label="管辖机构名称：">
          <Input v-model="searchParam.governingBodyName" clearable placeholder="请输入管辖机构名称..."></Input>
        </FormItem>
        <FormItem prop="governingBodyType" label="管辖机构类型：">
          <Input v-model="searchParam.governingBodyType" clearable placeholder="请输入管辖机构类型..."></Input>
        </FormItem>
        <FormItem prop="governingBodyRemark" label="管辖机构备注：">
          <Input v-model="searchParam.governingBodyRemark" clearable placeholder="请输入管辖机构备注..."></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long @click="commitSearch">检索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "governing_body_menu",
  computed: {
    divStyle() {
      var style = {};
      if(this.$parent.$refs.mainContent){
          style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      }else{
          style.width = window.innerWidth - 279 + "px";
      }
      // style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    }
  },
  created() {
    this.request();
  },
  mounted() {
    this.showPage();
  },
  data() {
    return {
      isLoading: false,
      isShowModalSearch: false,
      searchParam: {},
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [
        {
          title: "管辖机构编号",
          key: "governingBodyId"
        },
        {
          title: "管辖机构名称",
          key: "governingBodyName"
        },
        {
          title: "管辖机构类型",
          key: "governingBodyType"
        },
        {
          title: "管辖机构备注",
          key: "governingBodyRemark"
        }
      ],
      height: window.innerHeight,
      isSpinShow: false,
      data5: [],
      isModalShow: false,
      modalButtonName: "新增",
      modalTitle: "新增机构",
      modalType: "add",
      parentNodeName: "",
      parentNodeId: 0,
      currentNodeName: "",
      currentNodeId: 0,
      currentNodeType: "",
      currentNodeRemark: "",
      addressTypeEnum: global.goveringbodytype,
      buttonProps: {
        type: "default",
        size: "small"
      }
    };
  },
  methods: {
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/governing/selectPage?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          that.dataCount = data.body.amount;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    request() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url: "/api/getGoveringBodyTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "载入机构信息成功"
          });

          console.log(that.data5);
          data.body[0]["render"] = (h, { root, node, data }) => {
            return (
              "span",
              {
                style: {
                  display: "inline-block",
                  width: "100%"
                }
              },
              [
                h("span", [
                  h("Icon", {
                    props: {
                      type: "ios-folder-outline"
                    },
                    style: {
                      marginRight: "8px"
                    }
                  }),
                  h("span", data.title)
                ]),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      marginLeft: "32px",
                      marginRight: "32px"
                    }
                  },
                  [
                    h("Button", {
                      props: Object.assign({}, that.buttonProps, {
                        icon: "ios-add",
                        type: "primary"
                      }),
                      style: {
                        width: "64px"
                      },
                      on: {
                        click: () => {
                          if (localStorage.getItem("isAdmin") == "false") {
                            that.isModalShow = false;
                            that.$Notice.info({
                              title: "提示",
                              desc: "您的权限不足！"
                            });
                            return;
                          } else {
                            that.append(root, node, data);
                          }
                        }
                      }
                    })
                    // ,
                    // h("Button", {
                    //   props: Object.assign({}, that.buttonProps, {
                    //     icon: "ios-create-outline",
                    //     type: "primary"
                    //   }),
                    //   on: {
                    //     click: () => {
                    //       that.edit(root, node, data);
                    //     }
                    //   }
                    // })
                  ]
                )
              ]
            );
          };
          that.data5 = data.body;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%"
          }
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline"
              },
              style: {
                marginRight: "8px"
              }
            }),
            h("span", data.title)
          ]),
          h(
            "span",
            {
              style: {
                display: "inline-block",
                marginLeft: "32px",
                marginRight: "32px"
              }
            },
            [
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-add"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.append(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-remove"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.remove(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-create-outline"
                }),
                on: {
                  click: () => {
                    this.edit(root, node, data);
                  }
                }
              })
            ]
          )
        ]
      );
    },
    append(root, node, data) {
      this.modalButtonName = "新增";
      this.modalTitle = "新增机构";
      this.modalType = "add";
      this.parentNodeName = node.node.title;
      this.currentNodeId = "";
      this.parentNodeId = data.id;
      this.isModalShow = true;
      const children = data.children || [];
      this.$set(data, "expand", true);
      this.$set(data, "children", children);
      this.isModalShow = true;
    },
    remove(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      const index = parent.children.indexOf(data);
      this.delAddressInfo(data.id);
    },
    edit(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      this.modalButtonName = "修改";
      this.modalTitle = "修改机构";
      this.modalType = "edit";
      this.parentNodeName = parent.title;
      this.parentNodeId = data.pid;
      this.currentNodeName = data.title;
      this.currentNodeRemark = data.remark;
      this.currentNodeId = data.id;
      this.currentNodeType = data.type;
      this.isModalShow = true;
    },
    delAddressInfo(id) {
      this.$Modal.confirm({
        title: "确认",
        content: "<p>确认删除当前节点及子节点信息？</p>",
        onOk: () => {
          var that = this;
          that.isSpinShow = true;
          $.ajax({
            url: "/api/delGoveringBody",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify({
              id: id
            }),
            dataType: "json",
            success: function(data) {
              console.log(data);
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.request();
              that.$Notice.success({
                title: "提示",
                desc: "机构基础信息删除成功"
              });
            },
            error: function(textStatus) {
              that.loading = false;
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    commitVerification() {
      if (!this.currentNodeName) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入机构名称！"
        });
        return false;
      }
      if (!this.currentNodeType) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入机构类型！"
        });
        return false;
      }
      return true;
    },
    modalButtonClick() {
      if (this.commitVerification()) {
        var that = this;
        that.isSpinShow = true;
        that.isLoading = true;
        that.isModalShow = false;
        $.ajax({
          url: "/api/updateBaseGoveRingBody",
          contentType: "application/json",
          type: "post",
          data: JSON.stringify({
            updateType: this.modalType,
            pid: this.parentNodeId,
            name: this.currentNodeName,
            type: this.currentNodeType,
            id: this.currentNodeId,
            remark: this.currentNodeRemark
          }),
          dataType: "json",
          success: function(data) {
            console.log(data);
            if (data.errorCode != 0) {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
              });
              return;
            }
            that.request();
            that.isModalShow = false;
            that.$Notice.success({
              title: "提示",
              desc: "机构基础信息升级成功"
            });
          },
          error: function(textStatus) {
            that.loading = false;
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常"
            });
          },
          complete: function() {
            that.isSpinShow = false;
            that.isLoading = false;
            that.currentNodeRemark = "";
            that.currentNodeName = "";
            that.currentNodeType = "";
          }
        });
      }
    },
    onClickSearch() {
      this.isShowModalSearch = true;
    },
    commitSearch() {
      console.log(this.searchParam);
      this.isShowModalSearch = false;
      this.showPage();
    }
  }
};
</script>
<style>
.ivu-tree {
  left: 30%;
}

.ivu-tree ul {
  /* list-style: none; */
  margin: 5px;
  padding: 0;
  font-size: 16px;
}
</style>
